<template>
  <div class="rechargeDetailed">
    <div class="personal-box comWidth">
      <CenterNav/>
      <div class="personal-right">
        <NavT :titleS="titleS"/>
        <div class="rightmain">
          <el-table
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
              prop="created_at"
              label="操作時間">
            </el-table-column>
            <el-table-column
              label="類型">
              <template slot-scope="scope">
                <span v-if="scope.row.process_type == 0">提现</span>
                <span v-if="scope.row.process_type == 1">基建费</span>
                <span v-if="scope.row.process_type == 2">商品消费</span>
                <span v-if="scope.row.process_type == 3">服务费</span>
                <span v-if="scope.row.process_type == 4">介绍费</span>
                <span v-if="scope.row.process_type == 5">首单奖励</span>
                <span v-if="scope.row.process_type == 6">划拨费</span>
                <span v-if="scope.row.process_type == 7">其它</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="amount"
              label="金額">
            </el-table-column>
            <el-table-column
              prop="admin_note"
              label="備註">
              <template slot-scope="scope">
                <span v-if="scope.row.order_sn">
                  <span v-if="scope.row.amount > 0">(訂單號：{{scope.row.order_sn}}) 購買商品贈送 </span>
                  <span v-else>(訂單號：{{scope.row.order_sn}}) 商城消費</span>
                </span>
                <span v-else>{{scope.row.admin_note}}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="all" style="text-align: right;">
            您當前的可用資金為：  <span>￥{{totalIntegral}}</span>
          </div>
        </div>
        <!--分页-->
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="pageSize">
        </el-pagination>
      </div>
    </div>
    </div>
</template>

<script>
  //nav
  import NavT from '@/pages/personalPage/NavT'
  //cNav
  import CenterNav from '@/pages/personalPage/CenterNav'
  import {bills} from '@/api/other'
  import {userInformation} from '@/api/authentication';
  export default {
    name: 'RechargeDetailed',
    components:{
      NavT,
      CenterNav
    },
    data () {
      return {
        titleS:'賬戶明細',
        num:0,
        page:1,
        total:0,//总页数
        pageSize:0,//每页显示个数
        totalIntegral:0,
        tableData: []

      }
    },
   created(){
        this.getBill(this.page)
        this.getInformation()
     window.scrollTo(0,0)
   },
    methods:{
      getBill(page){ // 获取积分明细
        bills(page).then(res =>{
          this.tableData = res.data.data
          this.total = res.data.meta.pagination.total;
          this.pageSize = res.data.meta.pagination.per_page;
        })
      },
      /*获取剩余余额*/
      getInformation(){
        userInformation().then(res =>{
          this.totalIntegral = res.data.user_money;
        })
      },
      handleSizeChange(val) {
      },
      handleCurrentChange(val) {
        this.getBill(val)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.all{
  text-align: right;
  span{
    margin: 0 20px;
    color: #0055a0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personalPage/assetCenterPage/AccountDetailed.vue